/* Anern dealer body interactions. No header/footer behavior. */
(() => {
 'use strict';
 const key='__anernDealerPageV1';
 if(window[key]){window[key].scan(document);return;}
 const prefix='anern-dealer-', instances=new Map();
 const sel=c=>'.'+prefix+c;
 const init=root=>{
  if(instances.has(root))return;
  const abort=new AbortController(), signal=abort.signal, urls=new Set();
  const state={abort,urls,selected:null};instances.set(root,state);
  const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal});
  const q=s=>root.querySelector(s),all=s=>[...root.querySelectorAll(s)];
  const page=()=>root.closest(sel('page'));
  const filterQuotes=filter=>{
   const grid=q(sel('quotes-grid'));if(!grid)return;
   grid.dataset.filter=filter;
   all(sel('quote-filters')+' button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===filter)));
   let count=0;
   all(sel('partner-quote')).forEach(item=>{
    const visible=filter==='all'||(filter==='other'?!['Venezuela','South Africa'].includes(item.dataset.country):item.dataset.country===filter);
    item.hidden=!visible;item.classList.remove(prefix+'is-highlighted');if(visible)count++;
   });
   const status=q(sel('filter-status'));if(status)status.textContent=count+' partner testimonials shown.';
  };
  state.filterQuotes=filterQuotes;
  const selectMarket=id=>{
   const button=all(sel('market-list')+' button').find(b=>b.dataset.market===id);if(!button)return;
   state.selected=button.dataset.country;
   all('[data-market]').forEach(b=>{
    const selected=b.dataset.market===id;b.setAttribute('aria-pressed',String(selected));b.classList.toggle(prefix+'is-selected',selected);
   });
   for(const [target,prop] of [['market-role','role'],['market-name','partner'],['market-summary','summary']]){
    const el=q('#'+prefix+target);if(el)el.textContent=button.dataset[prop]||'';
   }
  };
  all('[data-market]').forEach(b=>on(b,'click',()=>selectMarket(b.dataset.market)));
  const marketButtons=all(sel('market-list')+' button');
  if(marketButtons.length)selectMarket(marketButtons[0].dataset.market);
  marketButtons.forEach((button,index)=>on(button,'keydown',e=>{
   let next;
   if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(index+1)%marketButtons.length;
   else if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(index-1+marketButtons.length)%marketButtons.length;
   else if(e.key==='Home')next=0;else if(e.key==='End')next=marketButtons.length-1;else return;
   e.preventDefault();marketButtons[next].focus();selectMarket(marketButtons[next].dataset.market);
  }));
  all(sel('quote-filters')+' button').forEach(b=>on(b,'click',()=>filterQuotes(b.dataset.filter)));
  on(q('#'+prefix+'market-link'),'click',()=>{
   const stories=page()?.querySelector('[data-anern-section="stories"]');const other=instances.get(stories);
   if(!other)return;
   other.filterQuotes(['Venezuela','South Africa'].includes(state.selected)?state.selected:'other');
   const quote=[...stories.querySelectorAll(sel('partner-quote'))].find(x=>x.dataset.country===state.selected);
   quote?.classList.add(prefix+'is-highlighted');
  });
  const form=q('form');let draft='';
  on(form,'submit',e=>{
   e.preventDefault();if(!form.reportValidity())return;
   const data=new FormData(form),safe=k=>String(data.get(k)||'').trim();
   const recipient=(form.dataset.recipient||'cooperation@anern.com').replace(/[\r\n?&#]/g,'');
   draft=['Anern Dealer Application','',`Full name: ${safe('name')}`,`Business email: ${safe('email')}`,`Company: ${safe('company')}`,`Country / Region: ${safe('country')}`,`Product interest: ${safe('interest')}`,'','Business details:',safe('message')].join('\n');
   q('#'+prefix+'draft-email').href='mailto:'+recipient+'?subject='+encodeURIComponent('Dealer Application — '+safe('company'))+'&body='+encodeURIComponent(draft);
   const status=q('#'+prefix+'form-status');status.hidden=false;status.textContent='Your application draft is ready. Open it in your email app or download a copy, then send it to '+recipient+'.';
   q(sel('form-result')).hidden=false;q('#'+prefix+'draft-email').focus();
  });
  on(q('#'+prefix+'download-draft'),'click',()=>{
   if(!draft)return;
   const url=URL.createObjectURL(new Blob([draft],{type:'text/plain;charset=utf-8'}));urls.add(url);
   const a=document.createElement('a');a.href=url;a.download='anern-dealer-application.txt';root.appendChild(a);a.click();a.remove();
  });
  on(root,'shopify:block:select',e=>{
   const el=e.target.closest('[data-anern-block]');if(!el)return;
   if(el.matches(sel('partner-quote'))){filterQuotes('all');el.classList.add(prefix+'is-highlighted');}
   if(el.dataset.market)selectMarket(el.dataset.market);
   if(el.dataset.filter)filterQuotes(el.dataset.filter);
  });
  on(root,'shopify:block:deselect',e=>e.target.closest(sel('partner-quote'))?.classList.remove(prefix+'is-highlighted'));
  // Preserve smooth in-page navigation without altering the store's html/body CSS.
  all('a[href^="#'+prefix+'"]').forEach(a=>on(a,'click',e=>{
   const target=page()?.querySelector(a.getAttribute('href'));if(!target)return;
   e.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
   history.replaceState(null,'',a.getAttribute('href'));
  }));
 };
 const scan=scope=>{if(scope.matches?.('[data-anern-section]'))init(scope);scope.querySelectorAll?.('[data-anern-section]').forEach(init);};
 const unload=scope=>{for(const [root,state] of instances)if(scope===root||scope.contains(root)){state.abort.abort();state.urls.forEach(u=>URL.revokeObjectURL(u));instances.delete(root);}};
 window[key]={scan,unload};
 document.addEventListener('shopify:section:load',e=>scan(e.target));
 document.addEventListener('shopify:section:unload',e=>unload(e.target));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
})();
